<div *ngIf="isLoading" class="flex items-center justify-center h-screen">
  <p-progressSpinner></p-progressSpinner>
</div>

<div class="container px-4 py-7">
  <block-ui>
    <div class="w-full form-container">
    <div class="w-full p-6 bg-white rounded-md shadow-lg">
      <h2 class="mb-4 text-2xl font-bold">Edit Customer</h2>
      <form [formGroup]="customerForm" (ngSubmit)="onSubmit()">
        <div class="mb-4 form-group">
          <label
            for="first_name"
            class="block text-sm font-medium text-gray-700">
            First Name:
          </label>
          <input
            pInputText
            id="first_name"
            formControlName="first_name"
            class="w-full mt-1" />
          <small
            *ngIf="
              customerForm.get('first_name')?.invalid &&
              customerForm.get('first_name')?.touched
            "
            class="text-red-500">
            First Name is required
          </small>
        </div>
        <div class="mb-4 form-group">
          <label
            for="last_name"
            class="block text-sm font-medium text-gray-700">
            Last Name:
          </label>
          <input
            pInputText
            id="last_name"
            formControlName="last_name"
            class="w-full mt-1" />
          <small
            *ngIf="
              customerForm.get('last_name')?.invalid &&
              customerForm.get('last_name')?.touched
            "
            class="text-red-500">
            Last Name is required
          </small>
        </div>
        <div class="mb-4 form-group">
          <label for="email" class="block text-sm font-medium text-gray-700">
            Email:
          </label>
          <input
            type="email"
            id="email"
            formControlName="email"
            class="w-full mt-1"
            placeholder="example@claddedglass.com" />
          <small
            *ngIf="
              customerForm.get('email')?.invalid &&
              customerForm.get('email')?.touched
            "
            class="text-red-500">
            Email is required
          </small>
        </div>
        <div class="mb-4 form-group">
          <label
            for="mobile_phone"
            class="block text-sm font-medium text-gray-700">
            Mobile Phone:
          </label>
          <input
            id="mobile_phone"
            formControlName="mobile_phone"
            class="w-full mt-1"
            placeholder="(999) 999-9999" />
          <small
            *ngIf="
              customerForm.get('mobile_phone')?.invalid &&
              customerForm.get('mobile_phone')?.touched
            "
            class="text-red-500">
            Mobile Phone is required
          </small>
        </div>

        <div class="mb-4 form-group">
          <label for="email" class="block text-sm font-medium text-gray-700">
            Line 1:
          </label>
          <p-autocomplete
            class="w-full mt-1"
            formControlName="line1"
            optionLabel="streetLine"
            (onSelect)="addressSelected($event)"
            [suggestions]="addressOptions"
            (completeMethod)="searchAddress($event)" />
          <small
            *ngIf="
              customerForm.get('line1')?.invalid &&
              customerForm.get('line1')?.touched
            "
            class="text-red-500">
            Line 1 is required
          </small>
        </div>

        <div class="mb-4 form-group">
          <label for="town" class="block text-sm font-medium text-gray-700">
            Town:
          </label>
          <input
            pInputText
            id="town"
            formControlName="town"
            class="w-full mt-1" />
          <small
            *ngIf="
              customerForm.get('town')?.invalid &&
              customerForm.get('town')?.touched
            "
            class="text-red-500">
            Town is required
          </small>
        </div>

        <div class="mb-4 form-group">
          <label for="state" class="block text-sm font-medium text-gray-700">
            State:
          </label>
          <input
            pInputText
            id="state"
            formControlName="state"
            class="w-full mt-1" />
          <small
            *ngIf="
              customerForm.get('state')?.invalid &&
              customerForm.get('state')?.touched
            "
            class="text-red-500">
            State is required
          </small>
        </div>

        <div class="mb-4 form-group">
          <label
            for="postal_code"
            class="block text-sm font-medium text-gray-700">
            Postal Code:
          </label>
          <input
            pInputText
            id="postal_code"
            formControlName="postal_code"
            class="w-full mt-1" />
          <small
            *ngIf="
              customerForm.get('postal_code')?.invalid &&
              customerForm.get('postal_code')?.touched
            "
            class="text-red-500">
            Postal code is required
          </small>
        </div>

        <div class="mb-4 form-group">
          <label
            for="autopay"
            class="block text-sm font-medium text-gray-700">
            Autopay:
          </label>
          <p-toggleswitch 
            id="autopay"
            formControlName="autopay_status"
            />
        </div>

        <div class="flex justify-start py-4">
          <button
            pButton
            type="submit"
            [disabled]="customerForm.invalid"
            class="rounded-md primary-btn">
            Save
          </button>
          <button
            pButton
            class="rounded-md primary-btn"
            (click)="cancel()">
            Cancel
          </button>
          <button
            pButton
            class="rounded-md primary-btn"
            (click)="resetPasswordLink()">
            Reset Link
          </button>
        </div>
        <div  class="flex justify-start py-4" *ngIf="this.passwordResetLink">
          <a [href]="this.passwordResetLink">{{this.passwordResetLink}}</a>
        </div>
    </form>
    </div>
  </div>
  </block-ui>
</div>
